/**
 * @generated SignedSource<<6103be7b908246bf954920609322c62a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorefrontHome_seller$data = {
  readonly " $fragmentSpreads": FragmentRefs<"StorefrontAboutSection_seller" | "StorefrontFeaturedSection_seller" | "StorefrontMediaSection_seller" | "useShowSellerSince_seller">;
  readonly " $fragmentType": "StorefrontHome_seller";
};
export type StorefrontHome_seller$key = {
  readonly " $data"?: StorefrontHome_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorefrontHome_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorefrontHome_seller",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorefrontAboutSection_seller"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorefrontMediaSection_seller"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorefrontFeaturedSection_seller"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShowSellerSince_seller"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "96f6a018832408b12236a3dac46adc57";

export default node;
